/** Stub — editing a submitted request is not yet supported. */
export default function TrainingCourseEditPage() {
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50 mx-auto max-w-2xl m-6 px-6 py-8 text-sm text-amber-800">
      Editing submitted training requests is not yet available.
    </div>
  );
}
